import ServiceApi from "src/services/models/ServiceApi.model";
import TradeService from "src/services/api/Trade.service";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import DocumentService from "src/services/api/Document.service";
import { DocumentCategoryEnum } from "src/components/Refatoracao/UploadDocument/DocumentCategoryEnum";
import { IDocument } from "src/services/interfaces/IDocument";
import { StorageTypeEnum } from "src/components/Refatoracao/UploadDocument/StorageTypeEnum";

export class Helpers {
  private setLoading: any;
  private setData: any;
  private tradeService: TradeService;
  private documentService: DocumentService;

  constructor(setLoading: any, setData: any, services: ServiceApi) {
    this.setLoading = setLoading;
    this.setData = setData;
    this.tradeService = services.tradeService;
    this.documentService = services.documentService;
  }

  public async fetch() {
    this.setLoading(true);
    await this.tradeService
      .getWithDocumentsByStatusAndPhase([TradeStatusEnum.Manual], [TradePhaseEnum.Cartorio, TradePhaseEnum.ContractSignatureAcceptenceTerm])
      .then(resp => this.setData(resp))
      .finally(() => this.setLoading(false));
  }

  public async DownloadDocument(document: IDocument, trade: any) {
    if (document.category === "CLICK_SIGN_CONTRACT") {
      await this.documentService.downloadContractByTradeId(trade.data.id);
    } else {
      await this.documentService.downloadDocumentByPath(document);
    }
  }

  public async handleSubmit(file) {
    await this.documentService.putGenericDocument(file);
  }

  public async handleChange(fileToUpload, idFromTrade, typeTitle) {
    this.setLoading(true);

    const documentUpload = {
      category:
        typeTitle === "CNH/RG"
          ? DocumentCategoryEnum.ID_OWNER
          : typeTitle === "Comprovante Residencial"
          ? DocumentCategoryEnum.RESIDENTIAL_CERTIFICATE
          : DocumentCategoryEnum.MARRIAGE_CERTIFICATE,
      tradeId: idFromTrade,
      storageType: StorageTypeEnum.S3,
      file: fileToUpload.file,
      fileName: fileToUpload.name,
      uploadDate: new Date()
    };

    this.handleSubmit(documentUpload).then(() => {
      this.fetch();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/monitor/upload/helpers.ts